var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amic_container lp_container"},[_c('SliderBuyOnline'),_vm._l((_vm.pageContentData.sections),function(component,index){return _c('mid',{key:'key' + index + _vm.uid(),attrs:{"component_data":component}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }